import { useParams } from 'react-router-dom';

interface PARAMS {
  [key: string]: string;
}

/**
 * Submits the form to create the deal
 * @return {{accountId: string, accountUserId: string} | null}
 */
export default function useAdminParams(): PARAMS {
  const params = useParams();

  const { accountId, accountUserId } = params;

  if (accountId && accountUserId) {
    return { accountId, accountUserId };
  }

  // check/run this for modals
  const { pathname } = window.location;

  if (!pathname) {
    return {};
  }

  const accountRegex = /\/accounts\/([a-zA-Z0-9]+)/;
  const userIdRegex = /\/users\/([a-zA-Z0-9]+)/;

  const accountMatch = pathname.match(accountRegex);
  const userIdMatch = pathname.match(userIdRegex);

  if (accountMatch?.length && userIdMatch?.length) {
    return { accountId: accountMatch[1], accountUserId: userIdMatch[1] };
  }

  return {};
}
